/* ==========================================================================
   HSquare — premium-layout.js
   Moves the "Estimated delivery" / "Return within 7 days" / "Guaranteed Safe
   Checkout" blocks from the product info column to a strip BELOW the product
   Description tab section.
   Safe to remove: just delete this asset and the matching <script> include
   in layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  // Inject a small style block once
  function injectStyles() {
    if (document.getElementById('hsq-trust-strip-styles')) return;
    var style = document.createElement('style');
    style.id = 'hsq-trust-strip-styles';
    style.textContent = [
      '.hsq-trust-strip{',
      '  max-width:1100px;',
      '  margin:8px auto 56px;',
      '  padding:0 16px;',
      '  display:flex;',
      '  flex-wrap:wrap;',
      '  gap:16px;',
      '  align-items:stretch;',
      '  justify-content:center;',
      '}',
      '.hsq-trust-strip > *{',
      '  flex:1 1 320px;',
      '  max-width:520px;',
      '  margin:0 !important;',
      '}',
      '.hsq-trust-strip .hdt-product__delivery-return,',
      '.hsq-trust-strip .hdt-product__trust-seal{',
      '  border:1px solid #e7e2d8;',
      '  border-radius:14px;',
      '  background:#ffffff;',
      '  padding:18px 16px;',
      '  box-sizing:border-box;',
      '}',
      '.hsq-trust-strip .hdt-product__delivery-return .hdt-row-grid{',
      '  display:grid;',
      '  grid-template-columns:1fr 1fr;',
      '  gap:0;',
      '}',
      '.hsq-trust-strip .hdt-product__delivery,',
      '.hsq-trust-strip .hdt-product__return{',
      '  text-align:center;',
      '  padding:0 12px;',
      '}',
      '.hsq-trust-strip .hdt-product__delivery + .hdt-product__return,',
      '.hsq-trust-strip .hdt-product__delivery{',
      '  border-right:1px solid #e7e2d8;',
      '}',
      '.hsq-trust-strip .hdt-product__return{',
      '  border-right:0 !important;',
      '}',
      '.hsq-trust-strip .hdt-product__trust-seal{',
      '  text-align:center;',
      '}',
      '@media (max-width: 720px){',
      '  .hsq-trust-strip{flex-direction:column;align-items:center;}',
      '  .hsq-trust-strip > *{flex:1 1 100%;max-width:100%;}',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function moveTrustElements() {
    // Only act on product pages
    if (!document.body || !document.body.classList.contains('hdt-page-type-product')) return;

    var deliveryReturn = document.querySelector('.hdt-product__delivery-return');
    var trustSeal      = document.querySelector('.hdt-product__trust-seal');

    // Find an anchor: the description tabs section.
    // Shopify wraps JSON-template sections as: <div id="shopify-section-template--{id}__tabs" ...>
    // so use a suffix-match plus class fallbacks.
    var anchor = document.querySelector('[id$="__tabs"].shopify-section')
              || document.querySelector('.hdt-section-main-product-tabs')
              || document.querySelector('[id*="__tabs"].shopify-section')
              || document.querySelector('section[id*="tabs"].shopify-section');

    if (!anchor) return;
    if (!deliveryReturn && !trustSeal) return;

    injectStyles();

    // Reuse existing wrapper if rerun (e.g. by Shopify section reload in theme editor)
    var wrap = document.getElementById('hsq-trust-strip');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'hsq-trust-strip';
      wrap.className = 'hsq-trust-strip';
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }

    if (deliveryReturn && deliveryReturn.parentNode !== wrap) wrap.appendChild(deliveryReturn);
    if (trustSeal      && trustSeal.parentNode      !== wrap) wrap.appendChild(trustSeal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveTrustElements);
  } else {
    moveTrustElements();
  }

  // Re-run after theme-editor section reloads
  document.addEventListener('shopify:section:load',  moveTrustElements);
  document.addEventListener('shopify:section:reorder', moveTrustElements);
})();
